import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="#B4B8BB" {...props}><path d="M13.85 15.97l-3.536-3.535-3.535 3.536a1.5 1.5 0 01-2.122-2.121l3.536-3.536-3.536-3.536a1.5 1.5 0 112.121-2.121l3.536 3.536 3.536-3.536a1.5 1.5 0 112.12 2.122l-3.535 3.535 3.536 3.535a1.5 1.5 0 11-2.122 2.122z" fillRule="evenodd" /></svg>);